const t = /* @__PURE__ */ Symbol("listVariant");
export {
  t as listVariantInjectionKey
};
